import { POI_COUNTRY_LIST_ID } from './constants';

// get scroll container (two elements above list due to extra div in scrollbar)
export const getCountryListScrollContainer = () =>
  document.querySelector<HTMLDivElement>(`#${POI_COUNTRY_LIST_ID}`)
    ?.parentElement?.parentElement;
